var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationicons({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.962 17.986H18.772C19.0372 18.0009 19.3018 17.9475 19.5405 17.8311C19.7793 17.7147 19.9842 17.5391 20.1358 17.321C20.2874 17.1029 20.3806 16.8497 20.4066 16.5853C20.4325 16.321 20.3903 16.0544 20.284 15.811C19.924 14.723 18.489 13.418 18.489 12.134C18.489 9.284 18.489 8.534 17.085 6.858C16.6307 6.31853 16.0673 5.88129 15.432 5.575L14.649 5.195C14.5176 5.11569 14.4043 5.00978 14.3163 4.88406C14.2283 4.75834 14.1675 4.61559 14.138 4.465C14.0597 3.9574 13.7913 3.49858 13.3873 3.18159C12.9832 2.86459 12.4736 2.71316 11.962 2.758C11.4596 2.72783 10.964 2.88601 10.572 3.20166C10.18 3.5173 9.91972 3.96774 9.84201 4.465C9.80676 4.62079 9.7377 4.76693 9.63972 4.89308C9.54174 5.01922 9.41723 5.12229 9.27501 5.195L8.49201 5.575C7.85704 5.88141 7.29406 6.31864 6.84001 6.858C5.43701 8.534 5.43701 9.284 5.43701 12.134C5.43701 13.418 4.06701 14.592 3.70701 15.745C3.49001 16.442 3.37001 17.986 5.18701 17.986H11.962Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.225 17.986C15.2336 18.4169 15.155 18.845 14.9941 19.2448C14.8331 19.6445 14.5931 20.0077 14.2884 20.3124C13.9837 20.6171 13.6205 20.8571 13.2208 21.0181C12.821 21.179 12.3929 21.2576 11.962 21.249C11.5311 21.2581 11.1027 21.18 10.7027 21.0192C10.3028 20.8585 9.93949 20.6184 9.63473 20.3136C9.32997 20.0087 9.09005 19.6454 8.92941 19.2453C8.76878 18.8453 8.69075 18.417 8.70002 17.986",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationicons);
export default __webpack_public_path__ + "static/media/notificationicons.ab6d54bd905c71631d9e3c36866537c5.svg";
export { ForwardRef as ReactComponent };